<template>
  <div class="flex flex-row overflow-auto w-full">
    <TheSideNavigationBar />
    <div class="flex-auto flex-grow flex-shrink bg-background-50" id="mainContent">
      <TheContentTopNavigationBar />
      <div class="w-full px-8">
        <div class="px-8 py-3 my-12 bg-white rounded container">
          <h4 class="font-subtitle-2 text-subtitle-1 my-6">Add New Category</h4>
          <div class="flex flex-row items-stretch gap-x-8 pt-6">
            <!-- <div class="inline-block align-top w-1/2 py-1 max-h-0">
              <InputImage type="avatar" />
            </div> -->

            <div class="inline-block align-middle w-1/2">
              <InputTextBox
                class="block"
                placeholder="Category name"
                @input="val => processValue(val,'article_category_name')"
                :warning="warning.article_category_name"
                warningClass="text-red-500"
                :disabled="disabled"
              ></InputTextBox>
              <!-- <InputTextBox
                type="email"
                class="block mt-3"
                placeholder="Email"
                :disabled="disabled"
                :warning="warning.email"
                warningClass="text-red-500"
                @input="val => processValue(val,'email')"
              ></InputTextBox> -->
            </div>
          </div>
          <!-- <div class="flex flex-row gap-x-8 py-3">
            <InputTextBox
              class="inline-block w-1/2 h-12"
              placeholder="NPWP"
              @input="val => processValue(val,'npwp')"
              :disabled="disabled"
              :warning="warning.npwp"
              warningClass="text-red-500"
            ></InputTextBox>
            <InputDropdown
              class="inline-block w-1/2 h-12"
              :options="['male', 'female']"
              placeholder="Gender"
              :disabled="disabled"
              @input="val => processValue(val,'gender')"
              :warning="warning.gender"
              warningClass="text-red-500"
            ></InputDropdown>
          </div>
          <div class="flex flex-row gap-x-8 py-6">
            <InputTextBox
              class="inline-block w-1/2 h-12"
              placeholder="Phone number"
              :disabled="disabled"
              @input="val => processValue(val,'phone')"
              :warning="warning.phone"
              warningClass="text-red-500"
            ></InputTextBox>
            <InputTextBox
              type="password"
              class="inline-block w-1/2 h-12"
              placeholder="Password"
              :disabled="disabled"
              @input="val => processValue(val,'password')"
              :warning="warning.password"
              warningClass="text-red-500"
            ></InputTextBox>
          </div>
          <div class="flex flex-row gap-x-8 py-6">
            <InputDropdown
              class="inline-block w-1/2 h-12"
              :options="['writter', 'auditor', 'admin', 'owner']"
              placeholder="Role"
              :disabled="disabled"
              @input="val => processValue(val,'role')"
              :warning="warning.role"
              warningClass="text-red-500"
            ></InputDropdown>
            <InputTextBox
              type="password"
              class="inline-block w-1/2 h-12"
              placeholder="Retype password"
              :disabled="disabled"
              @input="val => processValue(val,'passwordVerify')"
              :warning="warning.passwordVerify"
              warningClass="text-red-500"
            ></InputTextBox>
          </div>
           -->
          <!-- <div class="flex flex-row gap-x-8 pt-6">
            <InputTextArea
              class="inline-block w-1/2"
              placeholder="Address"
              :disabled="disabled"
              @input="val => processValue(val,'alamat')"
              :warning="warning.alamat"
              warningClass="text-red-500"
            ></InputTextArea>
            <div class="inline-block w-1/2 h-12"></div>
          </div> -->
          <div class="my-12 w-full">
            <Loading :show="!CATEGORY_READY" />
            <Alert relative normal v-show="storeError">Failed to create new category.</Alert>
          </div>
          <div class="my-12 w-full">
            <ButtonSolidBox color="secondary" class="px-8" @click="submitForm()">
              {{ getSubmitButtonLabel() }}
            </ButtonSolidBox>
          </div>
        </div>
        <Modal name="user" :show.sync="showModal"  strict-close>
          <div class="flex flex-col align-items-center w-full p-12">
            <div class="mx-auto my-8 text-center">
              <svg
                class="block mx-auto"
                width="64"
                height="64"
                viewBox="0 0 64 64"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M63.25 32C63.25 49.2589 49.2589 63.25 32 63.25C14.7411 63.25 0.75 49.2589 0.75 32C0.75 14.7411 14.7411 0.75 32 0.75C49.2589 0.75 63.25 14.7411 63.25 32Z"
                  fill="white"
                  fill-opacity="0.12"
                />
                <path
                  d="M63.25 32C63.25 49.2589 49.2589 63.25 32 63.25C14.7411 63.25 0.75 49.2589 0.75 32C0.75 14.7411 14.7411 0.75 32 0.75C49.2589 0.75 63.25 14.7411 63.25 32Z"
                  fill="#48D5D1"
                  fill-opacity="0.12"
                />
                <path
                  d="M63.25 32C63.25 49.2589 49.2589 63.25 32 63.25C14.7411 63.25 0.75 49.2589 0.75 32C0.75 14.7411 14.7411 0.75 32 0.75C49.2589 0.75 63.25 14.7411 63.25 32Z"
                  stroke="#48D5D1"
                  stroke-width="1.5"
                />
                <path
                  d="M46.334 26.0133L28.706 43.6414L17.666 32.6014L23.028 27.2395L28.706 32.9174L32 29.6234L40.972 20.6514L46.334 26.0133Z"
                  fill="#48D5D1"
                />
              </svg>
              <div class="block mt-12 font-headline-6 text-headline-6 text-gray">
                Category has been added!
              </div>
              <div
                class="block font-body-1 text-body-1 text-gray-500 max-w-sm mb-5"
              >
                Category has been added successfully.
              </div>
              <ButtonSolidBox v-show="CATEGORY_READY" class="px-8" @click="closeModal()">
                Ok
              </ButtonSolidBox>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>

<style scoped>
 </style>

<script>
import TheSideNavigationBar from '@/components/TheSideNavigationBar.vue'
import TheContentTopNavigationBar from '@/components/TheContentTopNavigationBar.vue'
// import InputImage from '@/components/Inputs/InputImage.vue'
import InputTextBox from '@/components/Inputs/InputTextBox.vue'
// import InputTextArea from '@/components/Inputs/InputTextArea.vue'
// import InputDropdown from '@/components/Inputs/InputDropdown.vue'
import ButtonSolidBox from '@/components/Buttons/ButtonSolidBox.vue'
import Loading from '@/components/Loading.vue'
import Alert from '@/components/Alert.vue'
import Modal from '@/components/Modal.vue'
import { createNamespacedHelpers } from 'vuex'

const category = createNamespacedHelpers('category')

export default {
  components: {
    Loading,
    Alert,
    InputTextBox,
    // InputDropdown,
    // InputTextArea,
    ButtonSolidBox,
    // InputImage,
    Modal,
    TheContentTopNavigationBar: TheContentTopNavigationBar,
    // TheSideCalendarBar: TheSideCalendarBar,
    TheSideNavigationBar: TheSideNavigationBar
  },
  data () {
    return {
      storeError: false,
      showModal: false,
      disabled: false,
      form: {
        article_category_name: ''
      },
      warning: {
        article_category_name: ''
      }
    }
  },
  computed: {
    ...category.mapGetters(['CATEGORY_READY'])
  },
  created () {
    this.createInit()
  },
  methods: {
    ...category.mapActions(['addCategory', 'createInit']),
    getSubmitButtonLabel () {
      if (
        Object.prototype.hasOwnProperty.call(this.$route.params, 'username') &&
        `${this.$route.params.username}`.length > 0
      ) {
        return 'Update'
      }
      return 'Add User'
    },
    processValue (value, target) {
      if (value === '') {
        this.warning[target] = 'This field is required'
      } else {
        if (this.warning[target] !== '') {
          this.warning[target] = ''
        }
        this.form[target] = value
      }
    },
    validate () {
      var validation = true
      Object.keys(this.form).forEach(val => {
        if (this.form[val] === '') {
          validation = false
          this.warning[val] = 'This field is required'
        }
      })
      return validation
    },
    submitForm () {
      if (this.validate()) {
        this.commit()
      }
    },
    commit () {
      this.storeError = false
      this.addCategory({ form: this.form }).then((data) => {
        if (data.data !== null) {
          this.form = data.data
          this.showModal = true
        }
      }).catch(err => {
        if (err.response !== undefined && err.response.status === 422) {
          err.response.data.data.forEach(val => {
            this.warning[val.path] = val.message
          })
        }
        this.storeError = true
      })
    },
    closeModal () {
      this.showModal = false
      this.showDetail(this.form.id)
    },
    showDetail (id) {
      this.$router.push({ name: 'route.dashboard.category.editor.detail', params: { id: id } })
    }
  }
}
</script>
